import { useEffect, useState } from 'react';
// import {View, Text, StyleSheet, ScrollView, Alert } from 'react-native';
// import FormInput from '../components/FormInput';
// import CustomButton from '../components/CustomButton';
// import SocialSignInButtons from '../components/SocialSignInButtons';
// import {useNavigation} from '@react-navigation/core';
// import {useForm} from 'react-hook-form';
// import {SignUpNavigationProp} from '../../../Types/navigation';
// import colors from '../../../themes/colors';
// import { signUp } from 'aws-amplify/auth';

import { useForm } from 'react-hook-form';
// import { signUp } from 'aws-amplify/auth';
// import { useAuthContext } from '../../../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Container, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import CustomModal from '../../components/Modals/CustomModal';
import i18n from "../../contexts/I18n"
import { useTranslation} from "react-i18next";
import axios from 'axios';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { ComByUserIdQuery, ComByUserIdQueryVariables, CreateAgendaCompanyMutation, CreateAgendaCompanyMutationVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables } from '../../graphql/API';
import { comByUserId, createAgendaCompany, updateAgendaUser } from './queries';
import { v4 as uuidv4 } from 'uuid';
import { useAuthContext } from '../../contexts/AuthContext';
import { getAgendaUser } from './queries';
import { Link } from 'react-router-dom';
import { Toast, ToastContainer } from 'react-bootstrap';

const CreateBraintreeAccount = async (email: string) => {
  try {
    console.log('POST', email);
    const response = await axios.post("/api/braintree/create_account", {
      'email': email,
    });

    console.log("Braintree Account Created:", response.data);
    return response.data; // Retourne l'ID du client Braintree
  } catch (error) {
    console.error("Erreur lors de la création du compte Braintree :", error);
    return null;
  }
};

const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const USERNAME_REGEX = /^[a-zA-Z0-9_]*$/; // alphanumeric and underscore

type CompanyData = {
  name: string;
  address: string;
  phoneNumber: string;
  // type: string;
  // account_type: string;
  // suspended: boolean;
};

const CreateCompanyScreen = () => {
  // I18N
  const { t } = useTranslation();
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // NAVIGATION
  const location = useLocation();
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const {register, control, handleSubmit, watch, reset} = useForm<CompanyData>();
  // const pwd = watch('password');
  const navigate = useNavigate();

  const {data: data, loading, error, refetch, fetchMore} = useQuery
      <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, {variables: {userId: AuthUserId}});

  const [getCompanyByUser, { data: dataCom, loading: loadingCom }] = useLazyQuery<ComByUserIdQuery, ComByUserIdQueryVariables>(comByUserId, {
      variables: { userId: AuthUserId },
    });

  const [doCreateCompany, {loading: loadingUpdate, error: errorUpdate}] = 
    useMutation<CreateAgendaCompanyMutation, CreateAgendaCompanyMutationVariables>(createAgendaCompany);

  const [updateUser, { data: dataUser, loading: loadingUser }] = useMutation<UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables>(updateAgendaUser);

  const user = data?.getAgendaUser

  useEffect(() => {
    document.title = t('title.createCompany');
  }, []);

  useEffect(() => {
    if (user) {
      getCompanyByUser();
    }
  }, [user]);

  const company = dataCom?.comByUserId?.items

  useEffect(() => {
    // if (company && company[0]) {
    //   if (company[0].userId == AuthUserId) {
    //     setContentModal(<>
    //       <Modal.Header closeButton>
    //         <Modal.Title>{t('company.only_one_account_title')}</Modal.Title>
    //       </Modal.Header>
    
    //       <Modal.Body>
    //         <p>{t('company.only_one_account_message')}</p>
    //       </Modal.Body></>);
    //     setLinkModal(t('link.dashboard'));
    //     setShowCustomModal(true);
    //   }
    // } else if (user) {
    //   if (user.comId) {
    //     setContentModal(<>
    //       <Modal.Header closeButton>
    //         <Modal.Title>{t('company.only_one_account_title')}</Modal.Title>
    //       </Modal.Header>
    
    //       <Modal.Body>
    //         <p>{t('company.only_one_account_message')}</p>
    //       </Modal.Body></>);
    //     setLinkModal(t('link.dashboard'));
    //     setShowCustomModal(true);
    //   }
    // }
  }, [company]);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  if (loading) {
    return (
      <div className="spinnerContainer">
          <Spinner animation="border" role="status" className="spinner">
              <span className="visually-hidden">Loading...</span>
          </Spinner>   
      </div>
    )
  };

  const generateCustomId = () => {
    const prefix = "ComApp";
    const uniquePart = uuidv4();
    return `${prefix}-${uniquePart}`;
  };

  const CreateAgendaCompany = async (formData: CompanyData, customerId: string) => {
    try {
      const comId = generateCustomId();
      const response = await doCreateCompany({
        variables: {
          input: {
            ...formData,
            userId: AuthUserId,
            comId: comId,
            suspended: false,
            customer_id: customerId,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          }
        }
      });
      return response
    } catch(error) {
      alert('ERROR :' + (error as Error).message)
      console.log((error as Error).message);
    }
  } 

  const onRegisterPressed = async ({name, address, phoneNumber, }: CompanyData) => {
    if (user){

      if (loadingState) {
        return;
      };
      // if (password != passwordRepeat) {
      //   setContentModal(<><Modal.Header closeButton>
      //     <Modal.Title>{t('company.password_error_title')}</Modal.Title>
      //         </Modal.Header>
        
      //         <Modal.Body>
      //           <p>{t('company.password_error_message')}</p>
      //         </Modal.Body></>);
      //   setShowCustomModal(true);
      //   return;
      // };
      setLoadingState(true);
      
      try {
        // console.log(name);
        const braintreeId = await CreateBraintreeAccount(user.email);
        if (braintreeId) {
          // console.log(braintreeId)
          // alert("Compte Braintree créé avec succès !");
          const response = await CreateAgendaCompany({name, address, phoneNumber}, braintreeId.customer_id);
          console.log('res', response)
          if (response && response.data.createAgendaCompany.comId) {
            await updateUser({variables: {input: {userId: user.userId, comId: response.data.createAgendaCompany.comId}}})
          }
        }
        
        setContentModal(<>
          <Modal.Header closeButton>
            <Modal.Title>{t('company.account_create_title')}</Modal.Title>
          </Modal.Header>
            
          <Modal.Body>
            <p>{t('company.account_create_message')}</p>
          </Modal.Body></>);
        setLinkModal(t('link.dashboard'));
        setShowCustomModal(true);
        // return
        // navigate('/cognito/confirmEmail');
      } catch (error) {
        console.log('Registration Error : ', error);
        // setContentModal(<><Modal.Header closeButton>
        //   <Modal.Title>{t('company.registration_error')}Registration Error</Modal.Title>
        //       </Modal.Header>
        
        //       <Modal.Body>
        //         <p>{(error as Error).message}.</p>
        //       </Modal.Body></>);
        // setShowCustomModal(true);
        // alert("Registering error: " + (error as Error).message);
      } finally {
        setLoadingState(false);
        // reset();
      };
    } else {
      alert('ouch');
    }
  };

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />

      <ToastContainer className="p-3 toastTop">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
          { toastTitle != "" &&
            <Toast.Header className={`text-center ${toastStatus}`}>
              <strong className="mx-auto text-white-50 text-center">{toastTitle}</strong>
            </Toast.Header>
          }
          <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
        </Toast>
      </ToastContainer>

      <Form className="register-form">
        <h2 className="text-center">{t('company.createTitle')}</h2>
        
        <Container className="">
          <Container className="ps-0 pb-4" >
            <Link to={t('link.dashboard')}>{t('home.backDashboard')}</Link>
          </Container>
          
        {/* <Form className="d-flex align-items-end">  */}
          {/* <Row className="align-items-end">
            <Col> */}
              <InputGroup>
                <Form.Control
                  placeholder={t('company.name')}
                  aria-label="name"
                  // aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("name")} 
                  name="name"
                />
              </InputGroup>

              <InputGroup>
                <Form.Control
                  placeholder={t('company.address')}
                  aria-label="email"
                  aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("address")}//("username")} 
                  name="address"
                />
              </InputGroup>
            {/* </Col>
            <Col> */}
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder={t('company.phone')}
                  className="me-lg-2" 
                  {...register("phoneNumber")} 
                  name="phoneNumber"
                />
              </InputGroup>
            {/* </Col>
            <Col> */}
              <InputGroup>
                <Button type="submit" onClick={handleSubmit(onRegisterPressed)} disabled={loadingState}>{loadingState ? t('signup.loading') : t('company.register')}</Button>
                {/* <Button type="button" onClick={goToRegister}>Register</Button> */}
              </InputGroup>
            {/* </Col>
          </Row> */}
          </Container>
        </Form>
        </>
  );
};

export default CreateCompanyScreen;
